import React, { useEffect, useState } from "react";
import {Link, useLocation} from "react-router-dom";
import {
    FiBriefcase,
    FiClock,
    FiHome,
    FiLogOut,
    FiMessageSquare,
    FiSend,
    FiSettings, FiPhone, FiInfo,
} from "react-icons/fi";
import {FaCertificate, FaPeopleArrows, FaQuestion, FaRegMoneyBillAlt, FaUserCircle} from "react-icons/fa";
import LogoMain from '../assets/images/logo-main.png';
import {RouteNames} from "../constants";
import {AuthUserI} from "../interfaces";
import {
    MdEventAvailable,
    MdOutlineCalculate,
    MdOutlineCancel,
    MdOutlineCropLandscape,
    MdWorkOutline
} from "react-icons/md";
import {GiWhistle} from "react-icons/gi";
import {BiTransfer} from "react-icons/bi";

interface PropsI{
    showSideBar: boolean;
    closeSideBar: ()=>void;
    user: AuthUserI
    logout: ()=>void;
}


const Sidebar = ({showSideBar, closeSideBar, user, logout }: PropsI) => {
    const location = useLocation();
    const [currentPagePath, setCurrentPagePath] = useState('')
    const [menuItems, setMenuItems] = useState([]); // Initialize with default items


    useEffect(() => {
        setCurrentPagePath(location.pathname);
    }, [location.pathname]);

useEffect(() => {
    if (user) {

      //  console.log('refreshing',user);
      //   console.log('val',user.isMPP===true);
        const updatedMenuItems = [
            {
              title: "Home",
              iconComponent: <FiHome />,
              route: RouteNames.HOME
            },
            {
              title: "Request Statement (self)",
              iconComponent: <FiClock />,
              route: RouteNames.REQUEST_STATEMENT
            },
            {
                title: "Request Statement (Third Party)",
                iconComponent: <FiClock />,
                route: RouteNames.REQUEST_STATEMENT_THIRD_PARTY
            },
            {
              title: "Transactions",
              iconComponent: <FaRegMoneyBillAlt />,
              route: RouteNames.TRANSACTIONS
            },
            {
              title: "Refer and Reward",
              iconComponent: <FiSend />,
              route: RouteNames.TRANSFER_RSA
            },
            {
              title: "Benefits",
              iconComponent: <MdOutlineCropLandscape />,
                route: RouteNames.TRACK_BENEFIT
            },
            {
                title: "Fund Transfer",
                iconComponent: <BiTransfer />,
                route: RouteNames.FUND_TRANSFER
            },
            // {
            //   title: "Registered A Friend",
            //   iconComponent: <FiBriefcase />,
            //     route: RouteNames.REGISTER_A_FRIEND
            // },
            {
                title: "Next of Kin",
                iconComponent: <FaPeopleArrows />,
                route: RouteNames.NEXT_OF_KIN
            },
            {
                title: "Beneficiaries",
                iconComponent: <FaPeopleArrows />,
                route: RouteNames.BENEFICIARIES
            },
            {
                title: "Pension Calculator",
                iconComponent: <MdOutlineCalculate />,
                route: RouteNames.PENSION_CALCULATOR
            },
            {
                title: "Employer",
                iconComponent: <MdWorkOutline />,
                route: RouteNames.EMPLOYER
            },
            {
                title: "VNIN",
                iconComponent: <FiBriefcase />,
                route: RouteNames.VIRTUAL_NIN
            },
            {
                title: "My Memorable Days",
                iconComponent: <MdEventAvailable />,
                route: RouteNames.MY_MEMORABLE_DAYS
            },
            {
                title: "Contribution Missing Months",
                iconComponent: <MdOutlineCancel />,
                route: RouteNames.MISSING_MONTHS
            },
            {
                title: "Self Contribution",
                iconComponent: <FaPeopleArrows />,
                route: RouteNames.SELF_CONTRIBUTION,
                hide: user.isMPP===false
            },
            //Is M
            {
                title: "Certificate of Registration",
                iconComponent: <FaCertificate />,
                route: RouteNames.CORG_REQUEST
            },
            // {
            //   title: "My Referrals",
            //   iconComponent: <FiShare2 />,
            //     route: RouteNames.MY_REFERRALS
            // },
            {
              title: "Feedback",
              iconComponent: <FiMessageSquare />,
              route: RouteNames.FEEDBACK
            },
            {
              title: "Whistle Blowing",
              iconComponent: <GiWhistle />,
              route: RouteNames.WHISTLE_BLOWING
            },
        ];
    
          setMenuItems(updatedMenuItems);
    //   reset({
    //     ...defaultValues,
    //     age: userInfo.age.toString(),
    //     gender: userInfo.gender,
    //   });
    }
  }, [user]);

    const openNewWindow = (url: string | URL | undefined) => {
        window.open(url, "_blank", "noopener,noreferrer");
      };
      

    
    return (
        <div className={`sidebar ${showSideBar ? 'show-side' : ''}`}>
            <div className="sidebar-logo">
                <img src={LogoMain} alt="" style={{
                    width: '100px'
                }}/>
            </div>
            <div className="sidebar-user">
                <div className="">
                    {
                        !user.image ?
                        <FaUserCircle className="sidebar-user-icon" />
                            :
                        <img src={`data:image/png;base64, ${user.image}`} alt="" className="sidebar-user-img" />
                    }
                </div>
                <div className="">
                    <div className="user-name">{`${user.firstName} ${user.surname}`}</div>
                    <div className="user-type">{user.userType}</div>
                </div>
            </div>
            <div className="sidebar-nav">
                { menuItems
                 .filter((item) => !item.hide)
                .map((item, index)=>(
                    <Link
                        to={item.route}
                        key={index}
                        onClick={closeSideBar}
                        className={`nav-item ${item.route === currentPagePath  ? 'active': '' }`}
                    >
                        <div className={`${item.route === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${item.route === currentPagePath ? 'font-bold': '' }`}>
                            {item.iconComponent}
                        </span>
                        {item.title}
                    </Link>
                    ))
                }
            </div>
            <div className="sidebar-footer">
                    <Link to={RouteNames.ACCOUNT_SETTINGS} className={`nav-item ${RouteNames.ACCOUNT_SETTINGS === currentPagePath ? 'active': '' }`} onClick={closeSideBar}>
                        <div className={`${RouteNames.ACCOUNT_SETTINGS === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${RouteNames.ACCOUNT_SETTINGS === currentPagePath ? 'font-bold': '' }`}>
                            <FiSettings />
                        </span>
                        Account Settings
                    </Link>
                    <Link to={RouteNames.SUPPORT} className={`nav-item ${RouteNames.SUPPORT === currentPagePath ? 'active': '' }`} onClick={closeSideBar}>
                        <div className={`${RouteNames.SUPPORT === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${RouteNames.SUPPORT === currentPagePath ? 'font-bold': '' }`}>
                            <FiPhone />
                        </span>
                        Support
                    </Link>
                    <Link to={RouteNames.FAQS} className={`nav-item ${RouteNames.FAQS === currentPagePath ? 'active': '' }`} onClick={closeSideBar}>
                        <div className={`${RouteNames.FAQS === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${RouteNames.FAQS === currentPagePath ? 'font-bold': '' }`}>
                            <FaQuestion />
                        </span>
                        FAQs
                    </Link>
                    <Link
  to={RouteNames.PRIVACY}
  className={`nav-item ${RouteNames.PRIVACY === currentPagePath ? 'active' : ''}`}
  onClick={closeSideBar}
  target="_blank" // Add this attribute to open in a new window
>
  <div className={`${RouteNames.PRIVACY === currentPagePath ? 'selected-bar' : ''}`}></div>
  <span className={`mr-4 text-xl ${RouteNames.PRIVACY === currentPagePath ? 'font-bold' : ''}`}>
    <FiInfo />
  </span>
  Privacy Policy
</Link>

{/* <a
  href={RouteNames.PRIVACY}
  className={`nav-item ${RouteNames.PRIVACY === currentPagePath ? 'active' : ''}`}
  onClick={(e) => {
    e.preventDefault();
    openNewWindow(RouteNames.PRIVACY);
    closeSideBar();
  }}
>
  <div className={`${RouteNames.PRIVACY === currentPagePath ? 'selected-bar' : ''}`}></div>
  <span className={`mr-4 text-xl ${RouteNames.PRIVACY === currentPagePath ? 'font-bold' : ''}`}>
    <FiInfo />
  </span>
  Privacy Policy
</a> */}

                <div className={`nav-item`} onClick={logout}>
                    <span className={`mr-4 text-xl`}>
                            <FiLogOut />
                        </span>
                    Logout
                </div>
            </div>
        </div>
    )
}
export default Sidebar;